import React from 'react';
import { cn } from '@restworld/utils-common';

export const MainWrapper = ({
  fullheight,
  className,
  ...props
}: { fullheight?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'w-full max-h-[90vh] lg:flex lg:flex-col lg:overflow-hidden lg:h-full',
      fullheight && 'h-[90%]',
      className
    )}
    {...props}
  />
);
export const HeaderWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      // rounded-t-2xl: the white header sits flush at the top of the rounded-2xl ModalContent (which
      // has no overflow-hidden), so its square corners would otherwise paint over the modal's rounded
      // top corners. Match the container radius so the top corners read as rounded.
      'hidden lg:flex shrink-0 bg-white border-b border-neutral-40 w-full justify-between items-center py-[10.5px] px-4 lg:p-3 lg:pl-10 rounded-t-2xl',
      className
    )}
    {...props}
  />
);
export const HeaderContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('', className)} {...props} />
);
export const BodyWrapper = ({
  fullheight,
  className,
  ...props
}: { fullheight?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('lg:flex lg:flex-1 lg:min-h-0', fullheight && 'h-full', className)} {...props} />
);
export const MainContentAndFooterWrapper = ({
  fullheight,
  isDefaultView,
  className,
  ...props
}: { fullheight?: boolean; isDefaultView?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'w-full relative lg:overflow-y-auto lg:h-full',
      fullheight && 'h-full',
      isDefaultView && 'md:h-[calc(100vh-184px)]',
      className
    )}
    {...props}
  />
);
export const MainContentWrapper = ({
  fullheight,
  className,
  ...props
}: { fullheight?: boolean } & React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('pt-2 px-5 lg:pt-5 lg:px-10', fullheight && 'h-full', className)} {...props} />
);
export const MainContentFooterWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('bottom-0 left-0 right-0 py-2 px-5 lg:py-8 lg:px-10 lg:h-fit', className)} {...props} />
);
export const SidePanelWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'p-2 mt-0 lg:w-[320px] lg:min-w-[320px] lg:h-[calc(100vh-120px)] lg:border-l lg:border-neutral-40 lg:p-5 lg:mt-0 hidden lg:block',
      className
    )}
    {...props}
  />
);

// Wraps on purpose: on a narrow screen the candidate's name already takes the
// full line, so the status chip and any association badge drop onto the line
// below it rather than squeezing the name.
export const ModalHeaderContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-wrap items-center gap-x-4 gap-y-2', className)} {...props} />
);
export const CandidateNameWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex gap-2', className)} {...props} />
);
export const SideContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-5', className)} {...props} />
);
export const BadgesWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-center gap-3', className)} {...props} />
);
export const LogoWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'border border-neutral-40 rounded-lg relative w-10 h-10 min-w-[2.5rem] flex items-center justify-center object-cover object-center overflow-hidden bg-white',
      className
    )}
    {...props}
  />
);
export const AppliedToContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn('bg-neutral-30 p-4 w-full flex flex-col gap-2 rounded-lg mt-3 lg:flex-row lg:gap-4', className)}
    {...props}
  />
);
export const RestaurantInfoWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('truncate', className)} {...props} />
);
export const CandidateModalSectionTitle = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <h3 className={cn('text-lg text-[#000000] font-semibold mb-4', className)} {...props} />
);
